import { api } from '../services/api'
import { useTermsAgreement } from './useTermsAgreement'

/**
 * 加盟店規約の本文と同意状態 (#1657)。本体は useTermsAgreement (EC 出店規約と共通)。
 */
export function useMerchantTerms() {
  return useTermsAgreement('merchant', api.getMerchantTerms, api.agreeMerchantTerms)
}
